<app-page-header
  [title]="pageTitle"
  [breadcrumbs]="breadcrumb"
></app-page-header>

<section class="content">
  <div class="container-fluid row">
    <div class="col-lg-12">
      <mat-card class="feed-type-card">
        <div *ngIf="isLoading" class="col-md-12 row justify-content-center">
          <mat-spinner></mat-spinner>
        </div>
        <mat-form-field class="col-md-12" appearance="outline">
          <mat-label>RSS Feed type</mat-label>
          <mat-select [formControl]="rssFeedType">
            <mat-option
              *ngFor="let feedType of ['News', 'Notices']"
              [value]="feedType"
            >
              {{ feedType }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card>

      <mat-card class="form-card">
        <div class="input-wrapper col-md-6" [formGroup]="newsForm">
          <label>bciti legacy</label>
          <mat-form-field appearance="outline">
            <mat-label>Legacy organisation id</mat-label>
            <input
              matInput
              type="number"
              formControlName="classic_organisation_id"
              placeholder="i.e. 12"
            />
          </mat-form-field>
        </div>
        <div class="col-lg-12" *ngIf="rssFeedType.value === 'News'">
          <label>News RSS feed configurations</label>

          <app-news-rss-feeds-form
            (submit)="submit()"
            [(newsForm)]="newsForm"
          ></app-news-rss-feeds-form>
        </div>

        <div class="col-lg-12" *ngIf="rssFeedType.value === 'Notices'">
          <label>Notices RSS feed configurations</label>

          <app-notices-rss-feeds-form></app-notices-rss-feeds-form>
        </div>

        <div class="col-lg-12 mt-4">
          <label>RSS providers</label>
          <app-rss-provider-form
            [providerType]="selectedProviderType"
            [(providersForm)]="providersForm"
            [isLoading]="isLoading"
          ></app-rss-provider-form>
        </div>

        <mat-card-footer class="save-button-container mt-3">
          <button
            mat-raised-button
            color="primary"
            [disabled]="isLoading"
            (click)="submit()"
          >
            Configure
          </button>
        </mat-card-footer>
      </mat-card>
    </div>
  </div>
</section>
